<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 10:32:49
 * @LastEditTime: 2020-05-26 15:27:53
 * @Description: 原 PSS 风格布局
 -->

<template>
  <div class="pss__layout">
    <pss-head />
    <pss-main>
      <slot />
    </pss-main>
    <pss-foot />
    <pss-process />
  </div>
</template>

<script>
import PssHead from './components/head/Index.vue';
import PssFoot from './components/foot/Index.vue';
import PssMain from './components/main/Index.vue';
import PssProcess from './components/Processing.vue';

export default {
  name: 'PssLayout',
  components: {
    PssHead,
    PssFoot,
    PssMain,
    PssProcess,
  },
};
</script>

<style lang="less" scoped>
.pss__layout {
  width: 100%;
  height: 100%;
  min-width: 1280px;
  min-height: 680px;
  background: url('../../assets/image/bg-body.jpg') top left repeat-x #000;
  font-size: 13px;
  color: @font-primary-color;
}
</style>
